<template>
  <div>
    <Navbar />
    <Header
      :titulo="nombreServicio"
      :desc="ministerioServicio"
      :urlPdf="urlPdf"
      :showYearSelect="true"
      :showDownloadButton="true"
    />
    <NavbarViews title="Recursos Humanos" :showYear="true" />

    <Content v-show="showData" />
    <Footer />
  </div>
</template>

<script>
import Navbar from "../../components/layout/Navbar.vue";
import Footer from "../../components/layout/Footer.vue";
import Content from "./components/Contents.vue";
import Header from "../../components/cabecera/Header.vue";
import NavbarViews from "../../components/navbar-from-inst/NavbarViews.vue";
import axios from "axios";
export default {
  components: {
    Navbar,
    Content,
    Header,
    Footer,
    NavbarViews,
  },
  data() {
    return {
      showData: true,
      nombreServicio: "Cargando...",
      ministerioServicio: " ",
      urlPdf: ""
    };
  },
  async mounted() {
    try {
      let idService = this.$route.params.id
      const servicio = await axios.get(`${process.env.VUE_APP_RUTA_API}/instituciones/servicios/${idService}/retrieve_public/`);

      this.urlPdf = servicio.data.files[0];
      const ministerio = await axios.get(`${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/${servicio.data.ministerio.id}`)
      if (!servicio.data || !ministerio.data) {
        this.nombreServicio = "En este momento no hay datos de este servicio";
        this.ministerioServicio = "Vuelva pronto";
        this.showData = false;
      } else {
        this.nombreServicio = servicio.data.nombre;
        this.ministerioServicio = ministerio.data.nombre;
        this.showData = true;
      }
      this.$store.commit("setSelectedInsView", "rrhh");
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
